import {ReactNode, RefObject} from 'react';
import {
  RouletteInfo,
  RouletteStatus,
  RouletteWinPrizeType,
} from '../../graphql/generated/types';

export type useRouletteDrawMutateHandler = (
  e: React.MouseEvent,
  isRedeem: boolean,
  redeem?: string
) => void;

export interface RouletteContainerProps {
  data: RouletteInfo;
  rouletteId: string;
  hasMapUid: boolean;
  rouletteAdLocId?: string;
}

export interface RoulettePageProps {
  input: string;
  onInput: (value: string) => void;
  onSubmit: React.MouseEventHandler<HTMLButtonElement>;
  onDraw: React.MouseEventHandler<HTMLButtonElement>;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
  onClickBanner?: React.MouseEventHandler<HTMLDivElement>;

  data: RouletteInfo;
  bannerRef?: (node?: Element | null) => void;
}

export interface RouletteBgProps {
  bgColor?: string;
  blurImageUrl?: string;
}

export interface RouletteBlurImageProps {
  imageUrl?: string;
  className?: string;
}

export interface RouletteTitleProps {
  children: ReactNode;
  className?: string;
}

export interface TitleProps {
  className?: string;
  children: string;
}

export interface SponsorTitleProps {
  sponsorBadgeUrl?: string;
  children: string;
}

export interface WinProps {
  prize: string;
  expirationDate?: string;
}

export interface RouletteProps {
  children: React.ReactNode;
  className?: string;
  showOutline: boolean;
  bgColor?: string;
  blurImageUrl?: string;
}

export interface ResultProps {
  children: React.ReactNode;
}

export interface PrizeProps {
  children: React.ReactNode;
}

export interface MaxCashProps {
  maxCashTextRef?: RefObject<HTMLParagraphElement>;
  maxCash: number;
  children: React.ReactNode;
}

export interface ImageProps {
  src: string;
  alt: string;
  isSponsorType?: boolean;
  className?: string;
}

export interface ErrorCaseProps {
  rouletteStatus: RouletteStatus;
  prize?: string;
  prizeType?: RouletteWinPrizeType;
  winningDate?: string;
  expirationDate?: string;
  apiErrorMsg?: string;
  children?: React.ReactNode;
}

export interface ButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export interface InputProps {
  value: string;
  onInput: (value: string) => void;
}

export interface RouletteInputProps {
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
}

export interface RouletteButtonProps {
  isRouletteEnd: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

export interface RouletteCaptionProps {
  title: string;
  labelList: string[];
  className?: string;
  showPrefixDot?: boolean;
}

export interface RouletteDABannerProps {
  className?: string;
  bannerImageUrl: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onImpressed?: VoidFunction;
  onImpressedOnce?: VoidFunction;
}

export enum RouletteLogType {
  Redeem = '응모번호',
  Cash = '캐시',
  Direct = '바로뽑기',
}
